/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 提交评论
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  req: cms.CloudTheaterCommentReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/cloundtheater-comments/comment`,
    data: req,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
